import React, { useState } from 'react';
import classnames from 'classnames';
import { ExpandArrowDownIcon, ExpandArrowUpIcon } from '../icons/icons';


interface IProps {
    title: string;
    children: React.ReactNode;
    isDefaultCollapsed?: boolean;
}

const CollapseSection = (props: IProps) => {
    const { isDefaultCollapsed = false, title, children } = props;
    const [isCollapsed, setIsCollapsed] = useState(isDefaultCollapsed);

    const onCollapseToggle = () => {
        setIsCollapsed(prev => !prev);
    };

    return (
        <div className={classnames('collapse-section', { 'collapse-section--collapsed': isCollapsed })}>
            <div className='collapse-section__item' onClick={onCollapseToggle}>
                <div className='collapse-section__title'>
                    {title}
                </div>
                <div className='collapse-section__icon'>
                    {isCollapsed ? <ExpandArrowDownIcon /> : <ExpandArrowUpIcon />}
                </div>
            </div>
            { !isCollapsed && <div className='collapse-section__content'>{children}</div>}
        </div>
    );
};

export default CollapseSection;
